var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombinedChargesDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.975 4.27417L12.5722 10.7904C12.4692 12.4552 12.4178 13.2877 12.0005 13.8862C11.7942 14.1821 11.5286 14.4318 11.2205 14.6195C10.5974 14.9991 9.76338 14.9991 8.0953 14.9991C6.42509 14.9991 5.58997 14.9991 4.96646 14.6188C4.6582 14.4308 4.39249 14.1806 4.18623 13.8842C3.76906 13.2848 3.71874 12.4512 3.61809 10.784L3.2251 4.27417",
    fill: "#E84242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.975 4.27417L12.5722 10.7904C12.4692 12.4552 12.4178 13.2877 12.0005 13.8862C11.7942 14.1821 11.5286 14.4318 11.2205 14.6195C10.5974 14.9991 9.76338 14.9991 8.0953 14.9991C6.42509 14.9991 5.58997 14.9991 4.96646 14.6188C4.6582 14.4308 4.39249 14.1806 4.18623 13.8842C3.76906 13.2848 3.71874 12.4512 3.61809 10.784L3.2251 4.27417",
    stroke: "#E84242",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15015 8.3269H10.0501",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 10.8748H9.07498",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25024 4.27498H13.9501M10.7362 4.27498L10.2925 3.35961C9.99778 2.75156 9.85036 2.44753 9.59615 2.25792C9.53979 2.21586 9.48006 2.17845 9.41759 2.14605C9.13608 2 8.79821 2 8.12248 2C7.42978 2 7.08347 2 6.79727 2.15218C6.73384 2.1859 6.67331 2.22483 6.61632 2.26856C6.35915 2.46585 6.21549 2.781 5.92818 3.4113L5.53449 4.27498",
    stroke: "#E84242",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombinedChargesDelete);
export default __webpack_public_path__ + "static/media/combined_charges_delete.033360535dc82034cc30deb315613d86.svg";
export { ForwardRef as ReactComponent };